import { atomWithStorage } from 'jotai/utils'
import staticConfig from 'src/config'
import { atom } from 'jotai'

export const lastChainIdAtom = atomWithStorage<number>(
  'lastChainId',
  staticConfig.defaultChain.id
)
export const termsAndAgreementsAtom = atomWithStorage<boolean>(
  'termsAndAgreements',
  false
)

export const authorizationsToQualifyAtom = atom<string[] | null>(null)

export const initialLoadingAtom = atom<boolean>(true)
